<template>
  <a :href="href" :target="target" @click="onClick"> <slot></slot> </a>
</template>

<script>
import ice from "../../../lib/ice";

export default {
  name: "vc-share-a",
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    }
  },
  methods: {
    onClick(event) {
      ice.onClickLink(event);
    }
  }
};
</script>
